import styled from '@emotion/styled';
import { AllowedColors, Button, colors, Modal, Text } from '@innovationdepartment/proxima-ui';
import { HELLO_EMAIL } from 'constants/emails';
import ButtonGroup from 'ui/ButtonGroup';

const Wrapper = styled.div`
  width: 400px;
  margin-bottom: 24px;

  & + * > .proxima-button {
    height: 36px;
  }
`;

const ShopifyRequiredModalView: React.FC<{
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}> = (props) => {
  const { open, onClose, onContinue } = props;

  return (
    <Modal title="Shopify Integration Required" open={open} onClose={onClose}>
      <Wrapper>
        <Text variant="body2" color="neutral80">
          An active integration with Shopify is required in order to activate a billing plan. Choose
          &ldquo;Continue&rdquo; in order to be redirected to our Shopify integration configuration
          page.
          <br />
          <br />
          Need help? Contact our support team at <a href={`mailto:${HELLO_EMAIL}`}>{HELLO_EMAIL}</a>
          .
        </Text>
      </Wrapper>
      <ButtonGroup>
        <Button
          size="small"
          label="Cancel"
          onClick={onClose}
          variant="outlined"
          color="secondary"
        />
        <Button
          overrideColors={{
            backgroundColor: 'linear-gradient(to right, #45EDBA, #89D0E9)',
            textColor: colors.neutral100 as AllowedColors,
          }}
          className="proxima-button"
          variant="contained"
          size="small"
          label="Continue"
          onClick={onContinue}
        />
      </ButtonGroup>
    </Modal>
  );
};

export default ShopifyRequiredModalView;
